export enum WidgetType {
  Overview,
  NoEventsWidget,
  ToolbarButton,
  Form,
  FormControl,
  MenuItem,
  FormButton,
}
